import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a1d0aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "color-picker" }
const _hoisted_2 = { class: "flex flex-row flex-wrap justify-center -ml-3 max-w-xs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "ml-5 mr-5 mb-4" }, null, -1))
const _hoisted_5 = { class: "flex flex-row flex-wrap justify-center -ml-3 max-w-xs" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gradients, (gradient) => {
        return (_openBlock(), _createElementBlock("div", {
          key: gradient,
          class: _normalizeClass(["color-picker__color flex-none ml-3 mb-4", { 'color-picker__color--selected': _ctx.isSelected(gradient) }]),
          style: _normalizeStyle({
          background: `linear-gradient(135deg, ${gradient.join(',')})`,
        }),
          onClick: ($event: any) => (_ctx.onClick(gradient))
        }, null, 14, _hoisted_3))
      }), 128))
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color) => {
        return (_openBlock(), _createElementBlock("div", {
          key: color,
          class: _normalizeClass(["color-picker__color flex-none ml-3 mb-4", { 'color-picker__color--selected': _ctx.isSelected(color) }]),
          style: _normalizeStyle({ background: color }),
          onClick: ($event: any) => (_ctx.onClick(color))
        }, null, 14, _hoisted_6))
      }), 128))
    ])
  ]))
}